import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, NgForm, NgModel } from '@angular/forms';
import { CheckboxCustomEvent } from '@ionic/angular';
import { QQQuestionViewModel } from 'src/app/models/qq-question.view-model';

@Component({
  selector: 'app-confirm-question',
  templateUrl: './confirm-question.component.html',
  styleUrls: ['./confirm-question.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class ConfirmQuestionComponent implements OnInit {

  @Input() question: QQQuestionViewModel;
  @ViewChild('formControl') formControl: NgModel;

  ngOnInit() {
  }

  async save(event: CheckboxCustomEvent) {
    if (!event.detail.checked) {
      this.formControl.control.setErrors({ required: true });
      return;
    }

    await this.question.setAnswer('true', true);
  }

}
